var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9985 1.16844L10.9988 1.1682L10.9985 1.16838V0.90584C10.9985 0.407641 10.593 0 10.0974 0L10.0971 0.000243819L10.0966 0.000643064L10.0974 0H0.901152L0.904704 0.00290468L0.901152 0.000243819C0.405544 0.000243819 0 0.407885 0 0.906106V7.09418C0 7.59238 0.405522 8 0.901152 8H1.22195H9.74924V7.99978C10.6946 7.98874 10.9785 7.75361 11 7.09489L10.9985 1.16844ZM9.426 0.221737L5.48469 3.14006L1.56901 0.221737H9.426ZM1.4448 2.48928L5.09565 5.01717L5.09931 5.01972L1.44271 7.57562L1.4448 2.48928ZM1.53917 7.77826L5.29243 5.15481L5.35827 5.20086C5.39613 5.22734 5.4402 5.2406 5.48427 5.2406C5.52799 5.2406 5.67779 5.15412 5.67779 5.15412L9.43207 7.77826H1.53917ZM9.52623 7.57404L5.87186 5.01975L7.90992 3.60857L9.52623 2.48942V7.57404Z",
    fill: "#971EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3855ddd22a8bce88babd2d6ae445e76d.svg";
export { ForwardRef as ReactComponent };